/**
 * Metro area groupings — when a user is detected in one city,
 * include all cities in the same metro for events/garages.
 * Key = any city slug in the group, Value = all city slugs in the metro.
 */
export const METRO_GROUPS: Record<string, string[]> = {
  // Twin Cities
  'minneapolis-mn': ['minneapolis-mn', 'saint-paul-mn', 'mankato-mn', 'st.-cloud-mn'],
  'saint-paul-mn': ['minneapolis-mn', 'saint-paul-mn', 'mankato-mn', 'st.-cloud-mn'],
  'mankato-mn': ['minneapolis-mn', 'saint-paul-mn', 'mankato-mn', 'st.-cloud-mn'],
  'st.-cloud-mn': ['minneapolis-mn', 'saint-paul-mn', 'mankato-mn', 'st.-cloud-mn'],

  // DFW
  'dallas-tx': ['dallas-tx', 'fort-worth-tx', 'arlington-tx', 'frisco-tx', 'denton-tx'],
  'fort-worth-tx': ['dallas-tx', 'fort-worth-tx', 'arlington-tx', 'frisco-tx', 'denton-tx'],
  'arlington-tx': ['dallas-tx', 'fort-worth-tx', 'arlington-tx', 'frisco-tx', 'denton-tx'],
  'frisco-tx': ['dallas-tx', 'fort-worth-tx', 'arlington-tx', 'frisco-tx', 'denton-tx'],
  'denton-tx': ['dallas-tx', 'fort-worth-tx', 'arlington-tx', 'frisco-tx', 'denton-tx'],

  // NYC Metro
  'new-york-ny': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],
  'brooklyn-ny': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],
  'east-rutherford-nj': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],
  'harrison-nj': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],
  'elmont-ny': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],
  'newark-nj': ['new-york-ny', 'brooklyn-ny', 'east-rutherford-nj', 'harrison-nj', 'elmont-ny', 'newark-nj'],

  // LA Metro
  'los-angeles-ca': ['los-angeles-ca', 'inglewood-ca', 'carson-ca', 'pasadena-ca', 'anaheim-ca', 'santa-clara-ca'],
  'inglewood-ca': ['los-angeles-ca', 'inglewood-ca', 'carson-ca', 'pasadena-ca', 'anaheim-ca'],
  'carson-ca': ['los-angeles-ca', 'inglewood-ca', 'carson-ca', 'pasadena-ca', 'anaheim-ca'],
  'pasadena-ca': ['los-angeles-ca', 'inglewood-ca', 'carson-ca', 'pasadena-ca', 'anaheim-ca'],
  'anaheim-ca': ['los-angeles-ca', 'inglewood-ca', 'carson-ca', 'pasadena-ca', 'anaheim-ca'],

  // Bay Area
  'san-francisco-ca': ['san-francisco-ca', 'san-jose-ca', 'santa-clara-ca', 'stanford-ca'],
  'san-jose-ca': ['san-francisco-ca', 'san-jose-ca', 'santa-clara-ca', 'stanford-ca'],
  'santa-clara-ca': ['san-francisco-ca', 'san-jose-ca', 'santa-clara-ca', 'stanford-ca'],
  'stanford-ca': ['san-francisco-ca', 'san-jose-ca', 'santa-clara-ca', 'stanford-ca'],

  // DC Metro
  'landover-md': ['landover-md', 'college-park-md', 'annapolis-md'],
  'college-park-md': ['landover-md', 'college-park-md', 'annapolis-md'],

  // South Florida
  'miami-fl': ['miami-fl', 'miami-gardens-fl', 'fort-lauderdale-fl', 'sunrise-fl', 'boca-raton-fl'],
  'miami-gardens-fl': ['miami-fl', 'miami-gardens-fl', 'fort-lauderdale-fl', 'sunrise-fl', 'boca-raton-fl'],
  'fort-lauderdale-fl': ['miami-fl', 'miami-gardens-fl', 'fort-lauderdale-fl', 'sunrise-fl', 'boca-raton-fl'],
  'sunrise-fl': ['miami-fl', 'miami-gardens-fl', 'fort-lauderdale-fl', 'sunrise-fl', 'boca-raton-fl'],

  // Tampa Bay
  'tampa-fl': ['tampa-fl', 'st.-petersburg-fl'],
  'st.-petersburg-fl': ['tampa-fl', 'st.-petersburg-fl'],

  // Philly
  'philadelphia-pa': ['philadelphia-pa', 'chester-pa', 'piscataway-nj', 'princeton-nj'],
  'chester-pa': ['philadelphia-pa', 'chester-pa'],

  // Chicago
  'chicago-il': ['chicago-il', 'evanston-il'],
  'evanston-il': ['chicago-il', 'evanston-il'],

  // Boston
  'boston-ma': ['boston-ma', 'foxborough-ma', 'chestnut-hill-ma', 'lowell-ma'],
  'foxborough-ma': ['boston-ma', 'foxborough-ma', 'chestnut-hill-ma'],
  'chestnut-hill-ma': ['boston-ma', 'foxborough-ma', 'chestnut-hill-ma'],

  // Denver
  'denver-co': ['denver-co', 'commerce-city-co', 'boulder-co'],
  'commerce-city-co': ['denver-co', 'commerce-city-co'],

  // Phoenix
  'phoenix-az': ['phoenix-az', 'glendale-az', 'tempe-az'],
  'glendale-az': ['phoenix-az', 'glendale-az', 'tempe-az'],
  'tempe-az': ['phoenix-az', 'glendale-az', 'tempe-az'],

  // Kansas City
  'kansas-city-mo': ['kansas-city-mo', 'kansas-city-ks'],
  'kansas-city-ks': ['kansas-city-mo', 'kansas-city-ks'],

  // Raleigh-Durham
  'raleigh-nc': ['raleigh-nc', 'durham-nc', 'chapel-hill-nc'],
  'durham-nc': ['raleigh-nc', 'durham-nc', 'chapel-hill-nc'],
  'chapel-hill-nc': ['raleigh-nc', 'durham-nc', 'chapel-hill-nc'],
};

export function getMetroSlugs(citySlug: string): string[] {
  return METRO_GROUPS[citySlug] || [citySlug];
}
